export const updateGTMDataLayerContext = (dataLayerObject) =>
  window.dataLayer && window.dataLayer.push(dataLayerObject);
